import { useQuery } from "@apollo/client";

import { GqlSettingsSpeciesGetAllParams } from "~/__generated__";
import useCacheFilterOptions from "~/modules/app/hooks/useCacheFilterOptions";

import { SettingsSpeciesListRoute_GetAllDocument } from "../queries.generated";

export default function useSettingsSpeciesListRoute_GetAll(params: GqlSettingsSpeciesGetAllParams) {
    const { data, loading, error } = useQuery(SettingsSpeciesListRoute_GetAllDocument, {
        variables: { params: params },
    });

    const queryInfo = data?.settingsSpeciesGetAll.queryInfo;
    const [, total] = useCacheFilterOptions(null, queryInfo?.paginationOption.total);
    return {
        loading,
        error,
        total: total,
        species: data?.settingsSpeciesGetAll.data,
    };
}
